import {
    ScenarioApi,
    CreateScenarioUserAccessRequest,
    ShareUserAccessDto,
} from '@api-clients/media-plan';
import { useApiConfiguration } from '@hooks/configuration';
import { useTranslation } from 'react-i18next';

import { useHelper } from '@shared/utils';

interface CreateUserScenarioAccessHook {
    createUserScenarioAccess: (
        userId: string,
        campaignId: string,
        scenarioId: string,
    ) => Promise<ShareUserAccessDto>;
}

type useCreateUserScenarioAccessProps = () => CreateUserScenarioAccessHook;

export const useCreateUserScenarioAccess: useCreateUserScenarioAccessProps = () => {
    const { getMediaPlanConfig } = useApiConfiguration();
    const { getDisplayedErrorMessage } = useHelper();

    async function createUserScenarioAccess(
        scenarioId: string,
        userId: string,
        campaignId: string,
    ): Promise<ShareUserAccessDto> {
        try {
            const config = await getMediaPlanConfig();
            const request: CreateScenarioUserAccessRequest = {
                scenarioId,
                userId,
                campaignId,
            };
            const api = new ScenarioApi(config);
            return await api.createScenarioUserAccess(request);
        } catch (e: any) {
            throw new Error(await getDisplayedErrorMessage(e));
        }
    }

    return {
        createUserScenarioAccess,
    };
};
